import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';
import { User } from '../model/user';

class UserService extends RestfulApiService<User> {
    public loadRoles() {
        return this.http.get<Record<string, string>>(`${this.getUrl()}/roles`);
    }

    public loadProfile() {
        return this.http.get<User>(`${this.getUrl()}/profile`);
    }

    protected getFormName(): string {
        return 'user';
    }

    protected getPath(): string {
        return 'users';
    }

    protected prepareSaveData(entity: ModelWithoutId<User>): ModelPrepped<User> {
        const userTxs = {
            ...entity,
            taxonomies: entity.taxonomies.map((taxonomy) => taxonomy.id),
        };

        return userTxs;
    }
}

export const userService = new UserService();
